<template>
  <div id="app">
    <div class="layout">
      <div class="content">
        <div class="content-left">
          <side-menu/>
        </div>
        <div class="content-right">
          <div class="header"></div>
          <div class="body">
            <mu-data-table :columns="columns" :sort.sync="sort" @sort-change="handleSortChange" :data="issues" :loading="loading" no-data-text="ไม่มีข้อมูล" rowKey="id">
              <template slot-scope="scope">
                <td :class="{'warning': scope.row.assignee == null}">{{scope.row.repository.name}}</td>
                <td :class="{'warning': scope.row.assignee == null}">{{scope.row.title}}</td>
                <td :class="{'is-center': true, 'warning': scope.row.assignee == null}">{{ scope.row.kind }}</td>
                <td :class="{'is-center': true, 'warning': scope.row.assignee == null}">{{ scope.row.type }}</td>
                <td :class="{'is-center': true, 'warning': scope.row.assignee == null}">{{ scope.row.priority }}</td>
                <td :class="{'is-center': true, 'warning': scope.row.assignee == null}">{{ scope.row.state}}</td>
                <td :class="{'is-center': true, 'text-danger': hourDiff(scope.row.updated_on) > 48, 'warning': scope.row.assignee == null}">{{ scope.row.updated_on | date('DD/MM/YYYY') }}</td>
              </template>
            </mu-data-table>
          </div>
          <div class="footer">
            ©2018-2019 Beehive Co., Ltd.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { differenceInHours } from 'date-fns'
import SideMenu from './components/SideMenu.vue'

export default {
  name: 'app',
  components: {
    SideMenu
  },
  data () {
    return {
      differenceInHours,
      loading: false,
      issues: [],
      errors: [],
      sort: {
        name: '',
        order: 'asc'
      },
      columns: [
        { title: 'Repository', width: 160, name: 'repo_name', sortable: true },
        { title: 'Title', width: 360, name: 'title' },
        { title: 'Kind', name: 'kind', width: 100, align: 'center', sortable: true },
        { title: 'Type', name: 'type', width: 100, align: 'center', sortable: true },
        { title: 'Priority', name: 'priority', width: 100, align: 'center', sortable: true },
        { title: 'Status', name: 'state', width: 100, align: 'center', sortable: true },
        { title: 'Updated On', name: 'updated_on', width: 126, align: 'center', sortable: true },
      ],
    }
  },
  methods: {
    hourDiff: function(date) {
      return differenceInHours(new Date(), date);
    },
    getIssues: function(filters) {
      this.loading = true;
      let kindsFilter = filters.kinds.length > 0 ? ' AND (kind = "'+ filters.kinds.join('" OR kind = "') +'")': '';
      this.$http.all(filters.repos.map(
        name => this.$http.get('https://api.bitbucket.org/2.0/repositories/beehivecoltd/' + name + '/issues', {
          params: {q: '(state = "open" OR state = "new")' + kindsFilter, sort: "-updated_on"}
        })
      ))
      .then(responses => {
        this.issues = responses.flatMap(reponse => reponse.data.values.map(val => {
          val.id = val.repository.name+'-'+val.id;
          val.repo_name = val.repository.name;
          return val;
        }));
        this.sort = {name: "updated_on", order: "asc"};
      })
      .catch(e => {
        this.errors.push(e)
      })
      .then(() => { // always executed
        this.loading = false;
      })
    },
    handleSortChange ({name, order}) {
      this.issues = this.issues.sort((a, b) => {
        var nameA = a[name].toUpperCase(); // ignore upper and lowercase
        var nameB = b[name].toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB)
          return -1 * (order === 'asc' ? 1 : -1);
        if (nameA > nameB)
          return 1 * (order === 'asc' ? 1 : -1);
        return 0;
      });
    }
  }
}
</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.layout{
}

.logo{
  font-size: 24px;
  color: white;
  text-align: center;
  color: #2c3e50;
  padding: 10px 20px;
}

.tab{
  margin: 0 auto;
  width: 400px;
}

.content{
  overflow: hidden;
}

.content-left{
  width: 30%;
  float: left;
  background-color: rgb(225, 225, 225);
  margin-bottom: -4000px;
  padding-bottom: 4000px;
}

.content-right{
  width: 70%;
  display: inline-block;
  float: right;
  background-color: rgb(236, 236, 236);
}

.header{
  background-color: white;
  height: 40px;
}

.body{
  min-height: 500px;
  background-color: white;
  margin: 10px 20px;
}

.footer{
  padding: 10px 0;
  text-align: center;
}

.text-danger {
  color: #e53935;
  font-weight: bold;
}
td.warning, td.warning td {
  background-color: #ffe0b2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue